import getCookieConsentPreferences from "../../utils/cookie-consent"
import { ResourceData } from "./gated-resources"

export function setDefaultHiddenFields(
  $form: HTMLFormElement,
  formInstanceId: string,
  pageTheme: string
) {
  const hiddenDefaultCTAField = $form.querySelector<HTMLInputElement>(
    "input[name='default_cta']"
  )
  const hiddenURLField = $form.querySelector<HTMLInputElement>(
    "input[name='page_url']"
  )
  const hiddenThemeField = $form.querySelector<HTMLInputElement>(
    "input[name='form_asset_topic']"
  )
  const hiddenAdOptOutField = $form.querySelector<HTMLInputElement>(
    "input[name='ad_opt_out']"
  )
  const hiddenDirectoryField = $form.querySelector<HTMLInputElement>(
    "input[name='page_url_directory']"
  )

  const dropdown = $form.querySelector<HTMLSelectElement>(
    ".hs-fieldtype-intl-phone select"
  )
  const hiddenField = $form.querySelector<HTMLInputElement>(
    "input[name='country___phone_number']"
  )

  if (hiddenDefaultCTAField) {
    const isDefaultForm = formInstanceId === "default-form"
    const fieldValue = isDefaultForm ? "true" : "false"
    hiddenDefaultCTAField.value = fieldValue
  }

  if (hiddenURLField) {
    hiddenURLField.value = window.location.origin + window.location.pathname
  }

  if (hiddenThemeField) {
    hiddenThemeField.value = pageTheme
  }

  if (hiddenDirectoryField) {
    const defaultDirectory = window.location.pathname.split("/")[1] || "home"
    hiddenDirectoryField.value =
      defaultDirectory === "p" ? "paid" : defaultDirectory
  }

  if (hiddenAdOptOutField) {
    const consentSettings = getCookieConsentPreferences()
    const optOut = consentSettings?.ad_storage === "denied" ? "true" : "false"
    hiddenAdOptOutField.value = optOut
  }

  if (dropdown && hiddenField) {
    const selectedOption = dropdown?.options[dropdown.selectedIndex]
    if (selectedOption) {
      hiddenField.value = selectedOption.value
    }
    dropdown.addEventListener("change", () => {
      const selectedOption = dropdown.options[dropdown.selectedIndex]
      if (selectedOption) {
        hiddenField.value = selectedOption.value
      }
    })
  }
}

export function setResourceHiddenFields(
  $form: HTMLFormElement,
  resourceData: ResourceData
) {
  const hiddenResourceField = $form.querySelector<HTMLInputElement>(
    "input[name='resource_download']"
  )
  const hiddenDownloadUrlField = $form.querySelector<HTMLInputElement>(
    "input[name='resource_download_url']"
  )

  if (hiddenResourceField) {
    hiddenResourceField.value = resourceData.title
  }

  if (hiddenDownloadUrlField) {
    const strippedUrl = window.location.origin + window.location.pathname
    hiddenDownloadUrlField.value = `${strippedUrl}?access-granted=${resourceData.secret}`
  }
}
